<template>
  <div class="counter-container">
    <div class="counter-glow">
      <div class="counter">
        <h5 class="counter-text">{{ counter }}</h5>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
const props = defineProps<{
  counter: number
}>()
</script>

<style scoped lang="scss">
.counter-container {
  cursor: pointer;
  width: 100px;
  height: 100px;
  padding-top: 64px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  transition:
    width 0.3s ease-in,
    height 0.3s ease-in;
  .counter-glow {
    z-index: 4;
    background-color: rgba(24, 36, 111, 0.08);
    width: 64px;
    height: 64px;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    transition:
      width 0.3s ease-in,
      height 0.3s ease-in;
    .counter {
      background-color: #fff;
      width: 50px;
      height: 50px;
      border: 1px solid var(--c-blue-100);
      border-radius: 50%;
      display: flex;
      justify-content: center;
      align-items: center;
      .counter-text {
        margin: 0;
      }
    }
  }
  @include breakpoint(tl) {
    width: 210px;
    height: 210px;
    padding-top: 0;
  }

  &.hover-counter-container {
    @include breakpoint(tl) {
      width: 274px;
      height: 274px;
      transition:
        width 0.3s ease-in,
        height 0.3s ease-in;
      .counter-glow {
        width: 90px;
        height: 90px;
        transition:
          width 0.3s ease-in,
          height 0.3s ease-in;
        .counter {
          width: 60px;
          height: 60px;
          transition:
            width 0.3s ease-in,
            height 0.3s ease-in;
        }
      }
    }
  }
}
</style>
